module.exports = __webpack_public_path__ + "static/media/greeneryB.819fd239.jpg";